export interface HouseRegionRelationItem {
  id: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13;
  nameLangKey: string;
  houses: number[];
}

export const houseRegionRelations: HouseRegionRelationItem[] = [
  {
    id: 1,
    nameLangKey: 'jura',
    houses: [111, 1112, 122, 131, 141],
  },
  {
    id: 2,
    nameLangKey: 'zentralesMittelland',
    houses: [211, 221, 222, 231],
  },
  {
    id: 3,
    nameLangKey: 'bernerMittelland',
    houses: [
      311, 312, 321, 322, 323, 331, 332, 333, 334, 341, 351, 352, 361, 362, 371, 381, 382, 383,
    ],
  },
  {
    id: 4,
    nameLangKey: 'brandboden',
    houses: [491, 492, 493, 494],
  },
  {
    id: 5,
    nameLangKey: 'westschweiz',
    houses: [511, 512, 513, 514, 531, 532, 533, 534, 551],
  },
  {
    id: 6,
    nameLangKey: 'oestlichesMittelland',
    houses: [611, 612, 613, 614, 621, 622, 641, 642, 643, 691, 692, 693, 694, 695],
  },
  {
    id: 7,
    nameLangKey: 'zentralschweiz',
    houses: [711, 712, 713, 721, 722, 723, 731, 741, 751, 752, 761],
  },
  {
    id: 8,
    nameLangKey: 'tessin',
    houses: [811, 812, 821, 832, 841, 842, 851, 852, 891, 892],
  },
  {
    id: 9,
    nameLangKey: 'ostschweiz',
    houses: [911, 912, 931],
  },
  {
    id: 10,
    nameLangKey: 'bernerOberland',
    houses: [1011, 1012, 1013, 1021, 1022, 1024, 1031, 1032, 1041, 1051, 1052, 1061],
  },
  {
    id: 11,
    nameLangKey: 'wallis',
    houses: [1111, 1112, 1113, 1121, 1122, 1131],
  },
  {
    id: 12,
    nameLangKey: 'graubuenden',
    houses: [1212],
  },
  {
    id: 13,
    nameLangKey: 'alpwirtschaft',
    houses: [1311, 1312, 1313, 1314, 1341, 1342, 1343, 1344, 1345, 1351, 1361, 1362, 1363, 1371],
  },
];

export const getRegionByHouseNr = (houseNr: number): HouseRegionRelationItem | undefined => {
  return houseRegionRelations.find((region) => {
    return region.houses.includes(houseNr);
  });
};

export const getRegionFullLabelByHouseNr = (houseNr: number | null | undefined): string => {
  if (!houseNr) {
    return '';
  }
  const region = getRegionByHouseNr(houseNr);
  return region ? `regions.${region.nameLangKey}` : String(houseNr);
};
